import { render, staticRenderFns } from "./WorkshopAdminViewModal.vue?vue&type=template&id=49edf5c5&scoped=true&"
import script from "./WorkshopAdminViewModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopAdminViewModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopAdminViewModal.vue?vue&type=style&index=0&id=49edf5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49edf5c5",
  null
  
)

export default component.exports